/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:23
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

import { Controller } from "stimulus"

export default class extends Controller {

    connect() {
      // console.log("-=> prospects_controller connected");
      $('.ui.form.prospect_edit')
        .form({
          fields: {
            fullname: {
              identifier: 'prospect[fullname]',
              rules: [{
                type: "empty",
                prompt: "You must supply a name"
              }]
            },
            email: {
              identifier: 'prospect[email]',
              rules: [{
                type: "empty",
                prompt: "You must supply an email address"
              }]
            },
            name: {
              identifier: 'prospect[name]',
              rules: [{
                type: "empty",
                prompt: "You must supply a label"
              }]
            }
          }
        })
      ;
    }

    initialize() {
      // console.log("-=> prospects_controller initialized");
    }

  };

// console.log("-=> prospects_controller loaded");


